jQuery(function () {
  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  const isEditor =
    document.body.classList.contains("block-editor-page") ||
    document.body.classList.contains("wp-admin");

  domReady(() => {
    if (isEditor) return;
    whenGsapReady(() => {
      whenScrollReady(() => {
        initHumanRegeneratorBanner();
      });
    });
  });

  function initHumanRegeneratorBanner() {
    const blocks = document.querySelectorAll(".js-hrb");
    if (!blocks.length) return;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    blocks.forEach((block) => {
      if (block.dataset.hrbInit === "1") return;
      block.dataset.hrbInit = "1";

      const items = block.querySelectorAll(".js-hrb-item");
      const parallaxTargets = block.querySelectorAll(".js-hrb-parallax");

      const strengthAttr = block.getAttribute("data-parallax");
      const strength = strengthAttr ? parseFloat(strengthAttr) : 240;

      const speedAttr = block.getAttribute("data-parallax-speed");
      const speed = speedAttr ? parseFloat(speedAttr) : 0.8;
      const factor = clamp(1 - speed, 0, 1);

      const computeOffset = (progress) => {
        const p = clamp(progress, 0, 1);
        const t = (p - 0.5) * 2;
        return -(t * strength * factor);
      };

      const applyOffset = (progress) => {
        if (!parallaxTargets.length) return;
        const off = computeOffset(progress);
        block.style.setProperty("--hrb-offset", `${off}px`);
      };

      if (reduceMotion) {
        if (items.length) {
          gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        }
        if (parallaxTargets.length) {
          block.style.setProperty("--hrb-offset", "0px");
        }
        return;
      }

      if (items.length) gsap.set(items, { autoAlpha: 0, y: 18 });

      const tlVars = {
        defaults: { ease: "power3.out", duration: 0.9 },
      };

      if (ScrollTrigger) {
        tlVars.scrollTrigger = {
          trigger: block,
          start: "top 75%",
          once: true,
          invalidateOnRefresh: true,
        };
      }

      const tl = gsap.timeline(tlVars);
      if (items.length) {
        tl.to(
          items,
          { autoAlpha: 1, y: 0, stagger: 0.1, clearProps: "transform" },
          0,
        );
      }

      if (!parallaxTargets.length) return;

      if (ScrollTrigger) {
        const st = ScrollTrigger.create({
          trigger: block,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
          onUpdate: (self) => applyOffset(self.progress),
          onRefresh: (self) => applyOffset(self.progress),
        });
        applyOffset(st.progress);
        return;
      }

      let ticking = false;
      const update = () => {
        ticking = false;
        const rect = block.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const total = rect.height + vh;
        const p = clamp((vh - rect.top) / total, 0, 1);
        applyOffset(p);
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      update();
    });
  }
});
